import React from "react";
import { HandshakeIcon } from "../components/HandshakeIcon";
import { Briefcase } from "lucide-react";

export const TOUR_FLAGS = {
  us: "/tour/flags/us.png",
  uk: "/tour/flags/gb.png",
  jp: "/tour/flags/jp.png",
  mx: "/tour/flags/mx.png",
  ca: "/tour/flags/ca.png",
};

export const TOUR_LABELS = {
  us: "US Fans",
  uk: "UK Fans",
  jp: "Japan Fans",
  mx: "Mexico Fans",
  ca: "Canada Fans",
  handshakes: "Handshakes",
  titleshots: "Titleshots in the Bank",
};

export const DAILY_CURRENCIES = ["handshakes", "titleshots"];

export const TOUR_CURRENCIES = ["us", "uk", "jp", "mx", "ca"];

// Bottom → top. Hit-testing walks this list in reverse.
export const CONTINENTS = [
  { id: "north_america", src: "/tour/World_Tour_North_America.webp", color: "#00C8FF" },
  { id: "europe", src: "/tour/World_Tour_Europe.webp", color: "#B44DFF" },
  { id: "latin_america", src: "/tour/World_Tour_Latin_America.webp", color: "#9D6BFF" },
  { id: "asia", src: "/tour/World_Tour_Asia.webp", color: "#39FF14" },
  { id: "africa", src: "/tour/World_Tour_Africa.webp", color: "#FF2FA8" },
];

export const fmtFans = (n) => {
  const v = Number(n || 0);
  if (v >= 1e6) return `${(v / 1e6).toFixed(2)}M`;
  if (v >= 1e4) return `${(v / 1e3).toFixed(1)}k`;
  return v >= 100 ? Math.floor(v).toLocaleString() : v.toFixed(v < 10 ? 2 : 1);
};

export const fmtAmt = (c, v) => (DAILY_CURRENCIES.includes(c) ? v : fmtFans(v));

export const Flag = ({ c, className = "w-5 h-3.5" }) =>
  c === "handshakes" ? <HandshakeIcon title={TOUR_LABELS[c]} className={className} />
  : c === "titleshots" ? <Briefcase className={`${className} text-[#FFE600] shrink-0`} style={{ filter: "drop-shadow(0 0 3px #FFE600)" }} aria-label={TOUR_LABELS[c]} />
  : (
    <img src={TOUR_FLAGS[c]} alt={TOUR_LABELS[c]} title={TOUR_LABELS[c]} className={`${className} object-cover rounded-[2px] shadow-[0_0_4px_rgba(0,0,0,0.8)] shrink-0`} />
  );
